/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Saved_ToastInputs */

const en_tags_manager_saved_toast = /** @type {(inputs: Tags_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tag set changes saved`)
};

const fr_tags_manager_saved_toast = /** @type {(inputs: Tags_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifications de l'ensemble de tags enregistrees`)
};

const de_tags_manager_saved_toast = /** @type {(inputs: Tags_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Änderungen am Tag-Satz gespeichert`)
};

const it_tags_manager_saved_toast = /** @type {(inputs: Tags_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifiche al set di tag salvate`)
};

const ru_tags_manager_saved_toast = /** @type {(inputs: Tags_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранены изменения в наборе тегов`)
};

const es_tags_manager_saved_toast = /** @type {(inputs: Tags_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios en el conjunto de etiquetas guardados`)
};

const zh_cn2_tags_manager_saved_toast = /** @type {(inputs: Tags_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标签集更改已保存`)
};

const ja_tags_manager_saved_toast = /** @type {(inputs: Tags_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグセットの変更を保存しました`)
};

const hi_tags_manager_saved_toast = /** @type {(inputs: Tags_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टैग सेट में किए गए बदलाव सहेज लिए गए।`)
};

const pt_pt2_tags_manager_saved_toast = /** @type {(inputs: Tags_Manager_Saved_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alterações no conjunto de tags salvas`)
};

/**
* | output |
* | --- |
* | "Tag set changes saved" |
*
* @param {Tags_Manager_Saved_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_saved_toast = /** @type {((inputs?: Tags_Manager_Saved_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Saved_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_saved_toast(inputs)
	if (locale === "de") return de_tags_manager_saved_toast(inputs)
	if (locale === "it") return it_tags_manager_saved_toast(inputs)
	if (locale === "ru") return ru_tags_manager_saved_toast(inputs)
	if (locale === "es") return es_tags_manager_saved_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_saved_toast(inputs)
	if (locale === "ja") return ja_tags_manager_saved_toast(inputs)
	if (locale === "hi") return hi_tags_manager_saved_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_saved_toast(inputs)
	return en_tags_manager_saved_toast(inputs)
});